import React from "react";

import {
  calculateFootprintingProgress,
  formatNumericCurrency,
  useGetFootprintingCropFootprints,
  useGetFootprintingFarmFootprint,
  useNavigate,
  useTranslation,
} from "utils";

import { CarbonProgram } from "models";

import { Button, Flex, Icon, LinedCard, ScreenSuccess } from "components";

export const FootprintingSuccessScreen = ({ carbonProgram, year, farmId }: { carbonProgram: CarbonProgram; year: number; farmId?: string }) => {
  const { t } = useTranslation(["footprinting"]);
  const navigate = useNavigate();

  const farmProgressQuery = useGetFootprintingFarmFootprint(farmId, year);
  const cropProgressQueries = useGetFootprintingCropFootprints(farmId, [year], carbonProgram.farmLevelFootprinting?.programCrops);

  const { totalPayout } = calculateFootprintingProgress(
    farmProgressQuery.data,
    cropProgressQueries.filter((cpq) => !!cpq.data).map((cpq) => cpq.data)
  );

  return (
    <ScreenSuccess headline={t("reviewSubmit.successScreen.headline", { year })} description={t("reviewSubmit.successScreen.description")}>
      <Flex className="success-data-card" vertical justify="center" align="center" gap="3rem">
        <LinedCard
          title={t("reviewSubmit.successScreen.payoutCard.dataInVerification")}
          titleIconName="tabler/clock"
          className="footprinting-payout-card"
          primary={
            <Flex className="footprinting-payout-card-content">
              <div className="footprinting-payout-card-co2-icon">
                <Icon iconName="klim/co2-emissions" />
              </div>
              <Flex flex={1}>{t("reviewSubmit.successScreen.payoutCard.payoutForYear", { year })}</Flex>
              <div className="footprinting-payout-card-amount">
                <Icon iconName="tabler/clock" />
                {formatNumericCurrency(totalPayout, { currency: carbonProgram.currency })}
              </div>
            </Flex>
          }
          color="grey"
        />

        <Button type="text" onClick={() => navigate("/footprinting")}>
          {t("review.close")}
        </Button>
      </Flex>
    </ScreenSuccess>
  );
};
